import {TextButton} from '../../index'

const SaveButton = ({className, onClick, disabled, noType}) => {
    return (
        <TextButton className={className} clickHandler={onClick} disabled={disabled} type={!noType&&"submit"}>Save</TextButton>
    )
}

export default SaveButton